import { getCanvasHeight, getCanvasWidth, PageFormat } from '@ritabygglov/core';
import { TITLE_BLOCK_Y_OFFSET } from '../TitleBlock/TitleBlock';

// Positioned a fixed margin from the right edge, and just above the title
// block (which always occupies the bottom-right corner, TITLE_BLOCK_Y_OFFSET
// px tall — see TitleBlock.tsx). Deriving the Y position from that offset
// directly, rather than a ratio of sheet height, is what guarantees no
// overlap on every sheet size: TITLE_BLOCK_Y_OFFSET is a fixed pixel amount,
// so a proportional guess drifts into it on shorter sheets (e.g. Tabloid,
// Arch D landscape).
export const ARROW_MARGIN_FROM_RIGHT_EDGE = 75;
export const ARROW_GAP_ABOVE_TITLE_BLOCK = 20;
export const ARROW_HALF_SIZE = 34; // half of the rendered arrow's bounding box

export const getArrowCenter = (pageFormat: PageFormat): [number, number] => {
  const width = getCanvasWidth(pageFormat);
  const height = getCanvasHeight(pageFormat);
  const titleBlockTop = height - TITLE_BLOCK_Y_OFFSET;
  return [
    width - ARROW_MARGIN_FROM_RIGHT_EDGE,
    titleBlockTop - ARROW_GAP_ABOVE_TITLE_BLOCK - ARROW_HALF_SIZE,
  ];
};
